import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import articles from "../pages/article/article";

const MetaDataUpdater = () => {
  const location = useLocation();
  const params = useParams();

  useEffect(() => {
    let title = "SwssDraw | Blockchain based draw system";
    let description =
      "SwssDraw is the world's first blockchain-based lucky draw platform, ensuring transparency, fairness, and rewards through smart contracts. Join now and win big!";

    if (location.pathname.startsWith("/articles/") && params.articleId) {
      const article = articles.find((a) => a.id === params.articleId);
      if (article) {
        title = article.title;
        description = article.description;
        if (article.keywords) {
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute("content", article.keywords);
        } else {
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute("content", "");
        }
      }
    } else {
      switch (location.pathname) {
        case "/":
          title = "SwssDraw | World's First Draw On Blockchain";
          description =
            "SwssDraw is the world's first blockchain-based lucky draw platform, ensuring transparency, fairness, and rewards through smart contracts. Join now and win big!";
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute(
              "content",
              "swssdraw, blockchain, lucky draw, crypto, web3, lottery, decentralized, transparent, fair, rewards, smart contracts"
            );
          break;
        case "/draw":
          title = "Draws | SwssDraw";
          description =
            "Participate in exciting draws on SwssDraw and win big prizes.";
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute(
              "content",
              "draws, participate, win prizes, swssdraw, lottery, crypto"
            );
          break;
        case "/contact-us":
          title = "Contact Us | SwssDraw";
          description = "Get in touch with SwssDraw support team.";
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute("content", "contact, support, swssdraw");
          break;
        case "/testimonials":
          title = "Testimonials | SwssDraw";
          description = "Read what our happy customers say about SwssDraw.";
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute(
              "content",
              "testimonials, reviews, happy customers, swssdraw"
            );
          break;
        case "/winners":
          title = "Winners | SwssDraw";
          description = "Check out the latest winners on SwssDraw.";
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute(
              "content",
              "winners, lottery winners, swssdraw, crypto winners"
            );
          break;
        case "/privacy-policy":
          title = "Privacy Policy | SwssDraw";
          description = "Understand SwssDraw's privacy policy.";
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute("content", "privacy policy, swssdraw, data privacy");
          break;
        case "/terms-condition":
          title = "Terms & Conditions | SwssDraw";
          description = "Read SwssDraw's terms and conditions.";
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute("content", "terms and conditions, swssdraw, legal");
          break;
        case "/disclaimer":
          title = "Disclaimer | SwssDraw";
          description = "Important disclaimers for SwssDraw platform.";
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute("content", "disclaimer, swssdraw, important notice");
          break;
        case "/referrals":
          title = "Referrals | SwssDraw";
          description = "Refer friends and earn rewards on SwssDraw.";
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute(
              "content",
              "referrals, earn rewards, swssdraw, crypto referral"
            );
          break;
        case "/articles":
          title = "Articles | SwssDraw";
          description = "Read articles about SwssDraw and blockchain.";
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute(
              "content",
              "articles, blockchain, swssdraw, crypto, lottery"
            );
          break;
        case "/referral-earning":
          title = "Referral Earning | SwssDraw";
          description =
            "Learn how to earn through SwssDraw's referral program.";
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute(
              "content",
              "referral earning, swssdraw, referral program, crypto rewards"
            );
          break;
        default:
          title = "SwssDraw | Blockchain based draw system";
          description =
            "SwssDraw is the world's first blockchain-based lucky draw platform, ensuring transparency, fairness, and rewards through smart contracts. Join now and win big!";
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute(
              "content",
              "swssdraw, blockchain, lucky draw, crypto, web3, lottery, decentralized, transparent, fair, rewards, smart contracts"
            );
          break;
      }
    }

    document.querySelector('meta[name="title"]').setAttribute("content", title);
    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", description);
    document.title = title;
  }, [location, params]);

  return null;
};

export default MetaDataUpdater;
